import { RootStore } from '~/stores/root.store';
import { ensureRootStoreInit, initApp } from '~/stores/root-store.utils';

let rootStore: RootStore = null;

export function init(
    runningApp: 'mainApp' | 'signup',
    overrideRootStore?: RootStore
): RootStore {
    rootStore =
        overrideRootStore ||
        (initApp({
            runningApp,
            currentRootStore: rootStore,
            rootStoreCreator: () => new RootStore()
        }) as RootStore);

    return rootStore;
}

// for test cleanup
export function cleanup() {
    rootStore = null;
}

export function getRootStore() {
    ensureRootStoreInit(rootStore);

    return rootStore;
}
